import './CardAction.2b8e7622ce8b84e2ed24ef6411e3b873.css';
export default {"cardAction":"_cardAction_1vwn3_1","button":"_button_1vwn3_1","ignoreResponsive":"_ignoreResponsive_1vwn3_1","content":"_content_1vwn3_1","icon":"_icon_1vwn3_1"};